export class HubjectPricingPlan {
  public id: string;
  public priceDescription: string;
  public currency: string;

  public constructor(init?: Partial<HubjectPricingPlan>) {
    Object.assign(this, init);
  }
}
